import React, { Component } from 'react'
import styled from 'styled-components'
import { Container, Row, Col, media } from 'styled-bootstrap-grid'
import Links from 'ui/components/generic/Links'
import { Relative } from 'ui/styles/utils'
import './industry_hero.css'


export default class IndustryHero extends Component {
  render() {
    const { image, title, url } = this.props

    return (
      <Wrapper image={image} className={'cover'}>
        <Container fluid>
          <h1>
            {title}
          </h1>
        </Container>
      </Wrapper>
    )
  }
}

const Wrapper = styled.div`
  h1{
    font-weight: 300 !important;
    font-size: 2.8em !important;
    ${media.lg`
    font-weight: 500 !important;
    `}
  }
  position: relative;
  padding: 12% 0 12%;
  overflow: hidden;
  margin: 80px 0 0;

  
  background: 
    /* top, transparent red */ 
    linear-gradient(
      rgba(0, 58, 112, 0.6), 
      rgba(0, 58, 112, 0.6)
    ),
    /* bottom, image */
    url(${props => props.image.sourceUrl});
    background-size: cover;
    background-position: center;
  text-align: center;
  color: white;
  

  ${media.lg`
  padding: 7% 0 7%;
  `}
`






// WEBPACK FOOTER //
// ./src/ui/components/modules/IndustryHero/index.js